/* Accessible navigation; native dialog supplies focus trapping and Escape. */
(() => {
  if (window.framedMobileInstalled) return;
  window.framedMobileInstalled = true;
  let opener;
  const unlock = () => {
    document.documentElement.classList.remove('fm-menu-open');
    opener?.focus();
  };
  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-fm-open]');
    if (open) {
      const dialog = document.getElementById(open.dataset.fmOpen);
      if (!dialog) return;
      opener = open;
      dialog.showModal();
      document.documentElement.classList.add('fm-menu-open');
      dialog.querySelector('[data-fm-close]')?.focus();
      dialog.addEventListener('close', unlock, {once:true});
    }
    const close = event.target.closest('[data-fm-close]');
    if (close) close.closest('dialog')?.close();
    if (event.target.matches('dialog.fm-menu')) {
      const r = event.target.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) event.target.close();
    }
  });
  const measure = () => {
    const header = document.querySelector('[data-fm-header]');
    document.body.style.setProperty('--header-height', `${header?.offsetHeight || 0}px`);
    document.body.style.setProperty('--header-group-height', `${document.getElementById('header-group')?.offsetHeight || header?.offsetHeight || 0}px`);
  };
  const observer = new ResizeObserver(measure);
  const bind = () => { observer.disconnect(); const header = document.querySelector('[data-fm-header]'); if (header) observer.observe(header); measure(); };
  bind();
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:section:unload', () => {document.documentElement.classList.remove('fm-menu-open'); bind();});
})();

/* Listen to native Shopify/Tinker variant events; never parse formatted price text. */
if (!customElements.get('fm-installments')) {
  customElements.define('fm-installments', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.section = this.closest('.shopify-section') || this.parentElement;
      this.section.addEventListener('variant:selected', this.onSelected, {signal:this.abort.signal});
      this.section.addEventListener('variant:update', this.onUpdate, {signal:this.abort.signal});
      this.updateAmount(this.dataset.price, this.dataset.available === 'true');
    }
    disconnectedCallback() { this.abort?.abort(); }
    belongs(event) {
      return !event.target.closest?.('product-card, quick-add-dialog') &&
        (!event.detail?.data?.productId || String(event.detail.data.productId) === this.dataset.productId || Boolean(event.detail.data.newProduct));
    }
    onSelected = (event) => {
      if (this.belongs(event)) this.updateAmount(null, false);
    };
    onUpdate = (event) => {
      if (!this.belongs(event)) return;
      const html = event.detail?.data?.html;
      if (html) {
        const fresh = Array.from(html.querySelectorAll('fm-installments')).find(el =>
          el.dataset.sectionId === this.dataset.sectionId && el.dataset.blockId === this.dataset.blockId);
        if (!fresh || fresh.dataset.currency !== this.dataset.currency) {this.updateAmount(null, false);return;}
        this.dataset.productId = fresh.dataset.productId;
        this.updateAmount(fresh.dataset.price, fresh.dataset.available === 'true');
      } else {
        const variant = event.detail?.resource;
        this.updateAmount(variant?.price, variant?.available === true);
      }
    };
    updateAmount(raw, available) {
      const line = this.querySelector('.fm-klarna__amount');
      const output = this.querySelector('[data-fm-installment-amount]');
      if (!line || !output) return;
      const price = Number(raw);
      if (raw == null || raw === '' || !available || !Number.isSafeInteger(price) || price <= 0) {line.hidden=true;return;}
      output.textContent = new Intl.NumberFormat('el-GR', {style:'currency',currency:this.dataset.currency || 'EUR'}).format(price / 300);
      line.hidden = false;
    }
  });
}
